import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class DealershipIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="15" height="24" viewBox="0 0 15 24"><path fillRule="evenodd" d="M7.5 0C3.351 0 0 3.44 0 7.729c0 1.116.236 2.144.618 3.11l6.47 12.89a.448.448 0 0 0 .824 0l6.47-12.89c.411-.937.618-1.993.618-3.11C14.999 3.44 11.647 0 7.5 0zm0 13.916c-3.353 0-6.088-2.808-6.088-6.249 0-3.44 2.735-6.248 6.087-6.248 3.353 0 6.088 2.808 6.088 6.248 0 3.443-2.735 6.25-6.088 6.25zm3.853-7.124h-.294c-.089 0-.206-.09-.206-.181L10.44 4.77c-.058-.242-.264-.422-.5-.422l-4.882-.001c-.235 0-.44.181-.5.422l-.41 1.842c-.03.09-.118.181-.206.181h-.295a.458.458 0 0 0-.44.453l-.002 1.72c0 .242.206.453.441.453h.294v.815c0 .242.206.453.442.453h.676a.458.458 0 0 0 .441-.453v-.815h4v.815c0 .242.206.453.442.453h.676a.458.458 0 0 0 .442-.453v-.815h.294a.458.458 0 0 0 .44-.452v-1.72a.459.459 0 0 0-.44-.454zM4.706 8.694a.597.597 0 0 1-.589-.603c0-.333.265-.604.589-.604.323 0 .588.271.588.604a.598.598 0 0 1-.588.603zm.616-1.75l.32-1.208h3.655l.32 1.207H5.322zm4.941 1.75a.597.597 0 0 1-.588-.603c0-.333.264-.604.588-.604.324 0 .589.271.589.604a.598.598 0 0 1-.589.603z"/></svg>
        )
    }
}

export default withCssClassName(DealershipIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/dealership-icon.js